import React from 'react';
import FeatureCard from '../composites/FeatureCard';

export type InitiativeOneSectionProps = {
  className?: string;
};

const InitiativeOneSection: React.FC<InitiativeOneSectionProps> = ({
  className = '',
}) => {
  const initiativeOneCards = [
    {
      icon: 'gear',
      image: '/logos/Master.svg',
      title: 'Master',
      description: 'I can build these tools',
    },
    {
      icon: 'pencil',
      image: '/logos/Maker.svg',
      title: 'Maker',
      description: 'I can co-create with these tools',
    },
    {
      icon: 'users',
      image: '/logos/Manager.svg',
      title: 'Manager',
      description: 'I can scale my output with these tools',
    },
  ];

  return (
    <div className={`bg-white w-full ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="space-y-6">
          <div className="space-y-2">
            <p className="text-sm font-semibold text-teal-600 uppercase tracking-wide">Initiative One</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              <span className="flex items-center">
                AI Literacy Uplift & Alignment
                <span className="ml-4 inline-block rounded-full bg-teal-200 text-teal-700 text-sm font-semibold px-2 py-1 whitespace-nowrap">
                  Coming soon
                </span>
              </span>
            </h2>
            <p className="text-lg font-semibold text-gray-700 leading-relaxed py-2">
              We know people at (i.e.,) will get value from AI in different ways—some by building, some by co-creating, others by simply getting more done. These three pathways reflect those different starting points. To kick things off, we've pulled together a small collection of curated content for each one.
            </p>
          </div>
          <div className="flex gap-4">
            <a href="/initiative-one/ai-literacy-uplift-and-alignment">
              <button className="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200">
                Learn more
              </button>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-8">
          {initiativeOneCards.map((card, idx) => (
            <FeatureCard
              key={card.title + idx}
              customImage={card.image}
              title={card.title}
              description={card.description}
              className="h-full"
              animate={true}
              delay={idx * 0.1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InitiativeOneSection; 